<template>
  <div class="news-wrapper main">
        <breadCrumb></breadCrumb>
        <div class="flex-between">
           <div class="left-section">
                <div class="subtitle student-subtitle">
                    <h2 class="">学员风采</h2>
                </div>
            <div class="student-list">
                <studentView  :width='253' :pWidth='281'></studentView>
            </div>
          </div>
          <div class="right-section">
            <div class="subtitle style-subtitle">
                <h2 class="">学员成果</h2>
            </div>
            <div class="style-list">
                <studentStyle :cloumn="2" :margin="20"></studentStyle>
            </div>
          </div>
        </div>
      </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
    @import "../less/news_common.less";
    .news-student {
        background-color: #fff;
        
        .left-section, 
        .right-section {
            width: 592px;
        }

        .student-list{
            padding-top: 28px;
            padding-right: 35px;
        }

        .style-list {
            padding-top: 21px;
        }
    }
</style>